import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-regular-svg-icons";
import userImage from "Dashboard/images/user.jpg";
import { IChatMessage } from "../domain/IChatMessage";
import { useSelector } from "react-redux";
import {
  selectState,
  setDeleteMessageModalOpen,
  setMessage
} from "../chat.slice";
import Loader from "components/Loader/Loader";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "hooks/hooks";
import { chatService } from "../services/chat.service";
import { debounce } from "lodash";
import { IEmployeeSimple } from "Dashboard/domain/IEmployeeSimple";

interface IProps {
  lastElementRef?: any;
  user: IEmployeeSimple;
  message: IChatMessage;
  index: number;
}

const ChatMessage = ({ lastElementRef, user, message, index }: IProps) => {
  const { loading } = useSelector(selectState);
  const [messageDate, setMessageDate] = useState<string>("")
  const dispatch = useAppDispatch()

  const formatMessageDate = (dateAndTime: string) => {
    let date = dateAndTime.slice(0, 10)
    date = new Date().toLocaleDateString('en-GB');
    let newDate = date + " - " + dateAndTime.slice(11, 19);
    setMessageDate(newDate)
  }

  const delayedUpdateVisibility = useMemo(
    () =>
      debounce(async (data: any) => {
        try {
          await chatService.updateVisibility(data);
        } catch (err) {
          console.log(err);
        }
      }, 1000),
    []
  );

  const onInputCheckboxChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const data = {
      messageId: message.message.messageId,
      [event.target.name]: event.target.checked
    }
    dispatch(setMessage(data));
    delayedUpdateVisibility(data);
  };

  useEffect(() => {
    formatMessageDate(message.message.dateTime);
  }, [message])

  return (
    <div className="chat-item" ref={lastElementRef}>
      {loading && <Loader />}
      <div className="chat-item-header">
        <span>
          <img src={userImage} width="100%" alt="img" />
        </span>
        <div className="user-div">
          <span className="user">{message.sender?.name}</span>
          (<span className="date-time">{messageDate}</span>)
        </div>
      </div>
      <div className="body">
        <p>{message.message.text}</p>
      </div>
      {message.sender?.employeeId === user.employeeId &&
        <input
          type="checkbox"
          className="chat-checkbox"
          name="isVisibleToAll"
          onClick={(e) => e.stopPropagation()}
          onChange={onInputCheckboxChange}
          checked={message.message.isVisibleToAll === true}
        />
      }
      {message.sender?.employeeId === user.employeeId &&
        <button
          className="close-button"
          onClick={(e) => {
            e.stopPropagation();
            dispatch(setDeleteMessageModalOpen({ visible: true, index }));
          }}
        >
          <FontAwesomeIcon icon={faTimesCircle} />
        </button>}
    </div>
  );
};

export default ChatMessage;
